
export default class MapText {
	
	constructor(el) {

		this.el = el;

		this.elms = { 
			map 		: this.el.querySelector('[data-map-config]'),
			template	: this.el.querySelector('[data-map-template]'),
		}

		this.initMapsText(el); 

	}

	initMapsText(elm){

		const map_json = this.elms.map.dataset.mapConfig;
    
		if(map_json){ 

			const data = JSON.parse(map_json);    
			
			const view = L.map(this.elms.map, {
				center			: [data['defaultLat'], data['defaultLng']],
				zoom			: data['zoom'],
				gestureHandling	: true
			});
			
			
			this.leafletMarkers = []; 
		
			this.leafletCluster = L.markerClusterGroup({
				iconCreateFunction: function(cluster) {
					return L.divIcon({ html: '<span class="hwc-cluster">' + cluster.getChildCount() + '</span>' });
				}
			});

			const icon = L.icon({
				iconUrl		: data['icon']['url'],
				iconSize	: [data['icon']['width'], data['icon']['height']],
				iconAnchor	: [data['icon']['anchorX'], data['icon']['anchorY']],
				popupAnchor	: [data['icon']['popupX'], data['icon']['popupY']], 
			});

			this.map = {
				view 		: view,  
				icon 		: icon,
			}  
			
			L.tileLayer('https://a.tile.openstreetmap.org/{z}/{x}/{y}.png', {
				attribution	: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
			}).addTo(this.map.view)
			
			this.setMarkers(); 

		} 

	}


	setMarkers(){
	
		const jsonMarkers = this.elms.map.dataset.markersConfig;
    
		if(jsonMarkers){ 
			
			var jsonArray = JSON.parse(jsonMarkers);
					
			if(jsonArray){

				jsonArray.forEach((item) => { 					
					this.setMarker(item); 
				});

				let boundingBox = new L.featureGroup(this.leafletMarkers)
				let newBounds = boundingBox.getBounds()
				if(newBounds.isValid()){
					this.map.view.fitBounds(newBounds, {
						maxZoom : 15,
						padding: [16, 16]
					});
				}
					
				this.map.view.addLayer(this.leafletCluster);

			}

		}

	}


	setMarker(marker){ 

		if(marker.lat && marker.lng){
			
			let leafletMarker = L.marker(
				{
					lat		: marker.lat,
					lng		: marker.lng
				},{ 
					icon	: this.map.icon 
				}
			)

			this.leafletMarkers.push(leafletMarker)
			
			this.leafletCluster.addLayer(leafletMarker); 

			// this.setPopup(marker, leafletMarker);

		}

	}

	getPopup(marker){ 

		let html_popup = document.importNode(this.elms.template.content, true);  
		
		if(typeof(marker.title) !== 'undefined' && marker.title != ''){		
			html_popup.querySelector('[data-map-item-title]').textContent = marker.title;  		
		}else{
			html_popup.querySelector('[data-map-item-title]').textContent = '';  		
		}
		
		if(typeof(marker.description) !== 'undefined' && marker.description != ''){			
			html_popup.querySelector('[data-map-item-description]').innerHTML = marker.description;  
		}else{
			html_popup.querySelector('[data-map-item-description]').innerHTML = '';  
		}
		
		if(typeof(marker.itinerary) !== 'undefined' && marker.itinerary != ''){			
			html_popup.querySelector('[data-map-item-link]').setAttribute('href', marker.itinerary);  
			html_popup.querySelector('[data-map-item-div]').classList.remove('is-hidden');  			
		}else{
			html_popup.querySelector('[data-map-item-link]').setAttribute('href', '');
			html_popup.querySelector('[data-map-item-div]').classList.add('is-hidden');  
		}

		return html_popup; 

	}


	setPopup(marker, leafletMarker){   

		const html = this.getPopup(marker);
		let popupWrapper = document.createElement('div');
		popupWrapper.appendChild(html);
		leafletMarker.bindPopup(popupWrapper.innerHTML);  
		
	} 

}